import React, { useEffect, useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import api from '../../services/api';
import StoreContext from '../../components/storage/context';
import BtnLoader from '../../components/buttons/loader/index.js';

const GoogleCallback = () => {
    const { search } = useLocation();
    const history = useHistory();
    const { setToken, setPKUser, setDisplayName, setGivenName, setRACF } = useContext(StoreContext);

    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const queryParams = new URLSearchParams(search);
        const code = queryParams.get('code');

        if (code) {
            // Envia o Authorization Code para a AWS Lambda
            api.post('accounts/login', { code: code })
                .then(response => {
                    const data = response.data;
                    setToken(data.token);
                    setPKUser(data.pk_user);

                    if (data.token) {
                        setDisplayName(data.full_name);
                        setGivenName(data.given_name);
                        setRACF(data.racf);
                        history.push('/');
                    } else {
                        setMessage(data.message || 'Erro ao validar token');
                        setLoading(false);
                    }
                })
                .catch(error => {
                    const errorMsg = error.response ? error.response.data.message : error.toString();
                    setMessage(errorMsg);
                    setLoading(false);
                });
        } else {
            setMessage('Nenhum código de autorização encontrado na URL.');
            setLoading(false);
        }
    }, [search, history, setToken, setPKUser, setDisplayName, setGivenName, setRACF]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f5f5f5' }}>
            <h2>Autenticando com o Google...</h2>
            <div style={{ width: '300px', marginTop: '20px' }}>
                {loading && <BtnLoader loading={true} messageLoading="Processando..." style="btn-loader-100-porcent" variant="primary" />}
            </div>
            {message && <p style={{ color: '#d32f2f', marginTop: '20px', fontWeight: 'bold' }}>{message}</p>}
            {message && (
                <button className="btn btn-secondary mt-3" onClick={() => history.push('/login')}>
                    Voltar para o Login
                </button>
            )}
        </div>
    );
};

export default GoogleCallback;
